import { render, staticRenderFns } from "./SmsHistoryDatatable.vue?vue&type=template&id=3a1a8c04&scoped=true&"
import script from "./SmsHistoryDatatable.vue?vue&type=script&lang=js&"
export * from "./SmsHistoryDatatable.vue?vue&type=script&lang=js&"
import style0 from "./SmsHistoryDatatable.vue?vue&type=style&index=0&id=3a1a8c04&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a1a8c04",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VChip,VDataTable,VTooltip})
